export const toNumberOrNull = (value: unknown): number | null => {
  if (value === '' || value == null) return null;

  const parsed = Number(value);

  return Number.isNaN(parsed) ? null : parsed;
};

export const NUMERIC = { setValueAs: toNumberOrNull };
